import CONFIG from 'Config';

export function extractInitials(string) {
	return string
		.split(' ')
		.map((segment) => `${segment[0]}`)
		.join('')
		.toUpperCase()
		.replace(/[^a-z0-9+]+/gi, '')
		.slice(0, 2);
}

export function camelCaseToSentenseCase(str) {
	const result = str.replace(/([A-Z])/g, ' $1');
	return result.charAt(0).toUpperCase() + result.slice(1);
}

export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}


// utils/loadGoogleMaps.js


export function loadGoogleMapsScript() {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    const existingScript = document.getElementById("googleMaps");
    if (existingScript) {
      existingScript.onload = () => resolve(window.google.maps);
      existingScript.onerror = reject;
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${CONFIG.googleMapsAndPlacesAPI}&libraries=places`;
    script.id = "googleMaps";
    script.async = true;
    script.defer = true;
    //script.onload = () => resolve(window.google.maps);
    script.onload = () => {
      // Google script loaded successfully
      const maps = window.google.maps;

      // 🪄 Global listener to hide any lingering .pac-container on blur
      document.addEventListener("click", (e) => {
        // Hide suggestion list when clicking outside of inputs or suggestions
        const isPAC = e.target.closest(".pac-container");
        const isInput = e.target.tagName === "INPUT";
        if (!isPAC && !isInput) {
          const pacContainers = document.querySelectorAll(".pac-container");
          pacContainers.forEach((el) => (el.style.display = "none"));
        }
      });

      resolve(maps);
    };
    //script.onerror = reject;
    script.onerror = (err) => {
      console.error("❌ Failed to load Google Maps script:", err);
      reject(err);
    };
    document.body.appendChild(script);
  });
}
